export const DEFAULT_WELL_SECTIONS = [
  { name: 'Best Wells', wells: [], expanded: false },
  { name: 'Best Surface Wells', wells: [], expanded: false },
  { name: 'Best Intermediate Wells', wells: [], expanded: false },
  { name: 'Best Production Vertical Wells', wells: [], expanded: false },
  { name: 'Best Production Lateral Wells', wells: [], expanded: false },
  { name: 'Best Production Curve Wells', wells: [], expanded: false },
];
